<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
      </div>
      <div class="content-body">
        <!-- Dashboard Ecommerce Starts -->
        <section id="dashboard-ecommerce">
          <div class="row match-height">


            <!-- Subscribers Chart Card starts -->
            <div class="col-lg-4 col-sm-6 col-12">
              <div class="card" style="cursor: pointer" @click="$router.push({name:'merchants'})">
                <div class="card-header flex-column  pb-0">
                  <div class="avatar bg-light-primary p-50 m-0">
                    <div class="avatar-content">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-users font-medium-5"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                    </div>
                  </div>
                  <h2 class="font-weight-bolder ">{{dashboardOverviewData?dashboardOverviewData.registeredMerchants:0}}</h2>
                  <p class="card-text">Registered Merchants</p>
                </div>
                <img style="max-height: 80px !important;" :src="`${publicPath}app-assets/images/icons/graph1.svg`"/>
              </div>
            </div>
            <!-- Subscribers Chart Card ends -->

            <!-- Subscribers Chart Card starts -->
            <div class="col-lg-4 col-sm-6 col-12">
              <div class="card" style="cursor: pointer" @click="$router.push({name:'app-users'})">
                <div class="card-header flex-column  pb-0">
                  <div class="avatar bg-light-primary p-50 m-0">
                    <div class="avatar-content">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-users font-medium-5"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                    </div>
                  </div>
                  <h2 class="font-weight-bolder ">{{dashboardOverviewData?dashboardOverviewData.registeredUsers:0}}</h2>
                  <p class="card-text">Registered Users</p>
                </div>
                <img style="max-height: 80px !important;" :src="`${publicPath}app-assets/images/icons/graph3.svg`"/>
              </div>
            </div>
            <!-- Subscribers Chart Card ends -->

            <!-- Orders Chart Card starts -->
            <div class="col-lg-4 col-sm-6 col-12">
              <div class="card border-info border-info" @click="$router.push({name:'customers'})" style="cursor: pointer; background: linear-gradient(298deg, #269ff8, transparent)">
                <div class="card-header flex-column  pb-0">
                  <div class="avatar bg-light-warning p-50 m-0">
                    <div class="avatar-content">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-package font-medium-5"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>
                    </div>
                  </div>
                  <h2 class="font-weight-bolder ">{{dashboardOverviewData?dashboardOverviewData.customers:0}}</h2>
                  <p class="card-text">Registered Customers</p>
                </div>
                <img style="max-height: 80px !important;" :src="`${publicPath}app-assets/images/icons/graph2.svg`"/>
              </div>
            </div>
            <!-- Orders Chart Card ends -->


          </div>

          <div class="row match-height">
            <div class="col-12">
              <div class="card card-company-table">
                <div class="card-body p-0">
                  <div class="m-2">
                    <div class="row">
                      <div class="col-12 d-flex justify-content-center">
                        <h5 class="font-weight-bolder">VaultsPay Balance</h5>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 d-flex justify-content-center">
                        <button type="text" class="btn btn-success btn-sm" @click="$router.push({name:'transaction-volume'})">Show Merchant Transaction Volume</button>
                      </div>
                    </div>
                  </div>
                  <div class="table-responsive">
                    <table class="table table-hover">
                      <thead class="bg-light-dark">
                      <tr>
                        <th class="font-small-1">Code</th>
                        <th class="font-small-1">Balance</th>
                        <th class="font-small-1">Type</th>
                        <th class="font-small-1">Action</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item,index) in vpBalance">
                        <td>
                          <div class="d-flex align-items-center">
<!--                            <div class="avatar bg-light-primary rounded">-->
<!--                              <div class="avatar-content">-->
<!--                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"-->
<!--                                     fill="none" stroke="#316992" stroke-width="2" stroke-linecap="round"-->
<!--                                     stroke-linejoin="round" class="feather feather-pocket avatar-icon font-medium-3">-->
<!--                                  <path-->
<!--                                      d="M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z"></path>-->
<!--                                  <polyline points="8 10 12 14 16 10"></polyline>-->
<!--                                </svg>-->
<!--                              </div>-->
<!--                            </div>-->
                            <div>
                              <small class="">{{ item.code }}</small>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <div class="avatar  mr-1">
                              <div class="avatar-content">
                                <img style="max-height: 25px;" :src="`${publicPath}app-assets/images/icons/coins.svg`"/>
                              </div>
                            </div>
                            <small>{{ modifyAmount(parseFloat(+(item.balance / 100))) }}</small>
                          </div>
                        </td>
                        <td>
                          <div class="d-flex align-items-center" v-if="item.merchant == 0">
                            <div class="avatar  mr-1">
                              <div class="avatar-content">
                                <img style="max-height: 25px;" :src="`${publicPath}app-assets/images/icons/user1.svg`"/>
                              </div>
                            </div>
                            <small>User</small>
                          </div>
                          <div class="d-flex align-items-center" v-else>
                            <div class="avatar  mr-1">
                              <div class="avatar-content">
                                <img style="max-height: 25px;" :src="`${publicPath}app-assets/images/icons/merchant1.svg`"/>
                              </div>
                            </div>
                            <small>Merchant</small>
                          </div>
                        </td>
                        <td>
                          <button class="btn btn-primary btn-sm" @click="$router.push({name:'user-stat-info',params:{
                            currencyId: item.currency_id, merchantStatus:item.merchant,
                            currencyCode:item.code
                          }})">View Details</button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Dashboard Ecommerce ends -->

      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
export default {
  mounted() {
    this.getDashboardOverviewStats()
  },
  data() {
    return {
      vpBalance: [],
      dashboardOverviewData: []
    }
  },
  methods: {
    getDashboardOverviewStats() {
      this.makeRequest("post", "v1/dashboard-overview", {currencyId: this.currencyId}, {}, false,false,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                this.dashboardOverviewData = responseData
                if (this.dashboardOverviewData) {
                  this.vpBalance = this.dashboardOverviewData.vpBalance
                }
              }
            }
          }
      );
    },
  }
}
</script>

